import { render, staticRenderFns } from "./Noteneingabe.vue?vue&type=template&id=c3bb043e"
import script from "./Noteneingabe.vue?vue&type=script&lang=js"
export * from "./Noteneingabe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports